<div class="receivedBy">
    <h1>Received Registration</h1>
    <br/>
    <span style="color:#53565A">Received By <span style="color:red;">*</span></span>
    <div class="form-group has-search" style="margin-top: 10px;">
        <span class="icon-ic_search form-control-search"></span>
        <input class="form-control frontIcon searchtext" style="width: 100%;" #received id="received" autocomplete="off" placeholder="Enter Name" [(ngModel)]="name">
    </div>
    <div class="d-flex justify-content-end" style="margin-right: -10px">
        <button (click)="Cancel()" class="button" type="button" style="background-color: #53565A;color:#fff">
            Cancel
        </button>
        <button [disabled]="this.name.length == 0 || this.name === ''" (click)="Submit()" class="button blue" type="button" style="background-color: #007CB0;">
            Submit
        </button>
    </div>
</div>